<template>
  <q-layout>
    <div class="page-header">
      <q-toolbar-title class="text-5 q-mr-auto q-ma-sm">{{ $t('log_mastertag') }}</q-toolbar-title>
      <q-breadcrumbs class="q-mr-auto q-ma-sm">
        <q-breadcrumbs-el :label="$t('dashboard')" to="/" />
        <q-breadcrumbs-el :label="$t('log')" />
        <q-breadcrumbs-el :label="$t('mastertag')" exact />
      </q-breadcrumbs>
    </div>
    <q-page padding>
      <header-mastertag-log />
      <list-mastertag-log />
    </q-page>
  </q-layout>
</template>

<script>
import HeaderMastertagLog from '../../components/mastertag/HeaderMastertagLog.vue';
import ListMastertagLog from '../../components/mastertag/ListMastertagLog.vue';

export default {
  name: 'MastertagLogList',
  components: { HeaderMastertagLog, ListMastertagLog }
};
</script>
